import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { NgIdleModule } from '@ng-idle/core';
import { NgxUiLoaderConfig, NgxUiLoaderModule, PB_DIRECTION, POSITION, SPINNER } from 'ngx-ui-loader';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from '@shared/modules/material/custom-mat-paginator-intl';
import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from '@shared/interceptors/global-error.interceptor';
import { AuthInterceptor } from '@shared/interceptors/auth.interceptor';
import { OktaAuthModule, OKTA_CONFIG, OktaAuthStateService } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '@environments/environment';

import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";


// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
// }

const oktaAuth = new OktaAuth(environment.okta);

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#007CAA',
  bgsOpacity: 0.9,
  bgsPosition: POSITION.centerCenter,
  bgsSize: 60,
  bgsType: SPINNER.foldingCube,
  blur: 7,
  fgsType: SPINNER.threeStrings,
  fgsColor: '#007CAA',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 60,
  overlayBorderRadius: '0',
  overlayColor: 'rgba(40, 40, 40, 0.8)',
  logoSize: 50,
  logoUrl: '',
  hasProgressBar: true,
  pbColor: '#9cc1f1',
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 3,
  text: '',
  textColor: '#FFFFFF',
  textPosition: POSITION.centerCenter,
  maxTime: -1,
  minTime: 300,
  gap: 50
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: 'assets/i18n/',
        suffix: '.json'
      })
    }),
    importProvidersFrom(
      ToastrModule.forRoot({ preventDuplicates: true }),
      NgIdleModule.forRoot(),
      NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
      OktaAuthModule
    ),
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    OktaAuthStateService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};
